





































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import VWeekPicker from "@/components/VWeekPicker.vue";
import YearsSelector from "@/components/SpecialInitiatives/YearsSelector.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import ComparisonGroupSelect from "@/components/ComparisonGroupSelect.vue";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import {
  Product,
  ProductsCollection,
  ProductsCatalog,
} from "@/models/SpecialInitiatives/Product";
import { Route } from "vue-router";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import {
  WeekPickerResult,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import SpecialInitiativesChart, {
  ChartWeekRange,
} from "@/components/SpecialInitiatives/Chart.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import CompanyService from "@/services/CompanyService";
import { Company } from "@/models";
import Broadcaster, {
  BroadcastersCatalog,
  BroadcastersCollection,
} from "@/models/SpecialInitiatives/Broadcaster";
import SpecialInitiativesTable, {
  SpecialInitiativesIData,
  SpecialInitiativesIColumn,
} from "@/components/SpecialInitiatives/SpecialInitiativesTable.vue";
import NumberFormatter from "@/services/NumberFormatter";
import GetColorMixin from "@/mixins/SpecialInitiatives/GetColorMixin";

@Component({
  components: {
    VWeekPicker,
    YearsSelector,
    VSwitchButton,
    MultiLevelSelect,
    ComparisonGroupSelect,
    HeatmapTable,
    SpecialInitiativesChart,
    VMultiSwitcher,
    VCheckButton,
    LogoWithFallback,
    SpecialInitiativesTable,
  },
})
export default class SpecialInitiativesClients extends Mixins(
  FiltersMixin,
  GetColorMixin
) {
  compareYearStart = 0;
  compareYearEnd = 0;
  disabled = false;
  loading = false;
  planCollapse = false;
  products: ProductsCatalog = {};
  broadcasters: BroadcastersCatalog = {};

  brandHeatmapColumns: HeatmapTableColumn[] = [];
  brandHeatmapRows: HeatmapTableRow[] = [];
  company: Company | null = null;
  taxonomyHeatmapColumns: HeatmapTableColumn[] = [];
  taxonomyHeatmapRows: HeatmapTableRow[] = [];

  taxonomyOptions = [
    {
      id: "sector",
      text: "Settore",
    },
    {
      id: "category",
      text: "Categoria",
    },
    {
      id: "class",
      text: "Classe",
    },
  ];

  taxonomyValue: "sector" | "category" | "class" = "sector";

  companyId = "";

  @Watch("taxonomyValue")
  onTaxonomyChangedValue(value: string) {
    this.initData();
  }

  @Watch("companyId")
  onCompanyIdChange(value: string) {
    this.loadData();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    if (to.params !== from.params) {
      this.companyId = to.params.companyId;
    } else {
      this.companyId = from.params.companyId;
    }
    this.loading = true;
    if (this.forceReloadFromApi) {
      this.company = await this.getCompany();
      await this.loadProducts();
      await this.loadBroadcasters();
      this.forceReloadFromApi = false;
    }
    await this.initData();
    this.loading = false;
    next();
  }

  get brandHeatmapSortColumn() {
    if (this.brandHeatmapColumns.length > 0) {
      return this.brandHeatmapColumns[2];
    } else {
      return null;
    }
  }

  get taxonomyHeatmapSortColumn() {
    if (this.taxonomyHeatmapColumns.length > 0) {
      return this.taxonomyHeatmapColumns[2];
    } else {
      return null;
    }
  }

  get title() {
    const subject = this.clientSubjectsEntries.find(
      (element) => element.id === this.clientSubject
    );
    return `Overview ${subject?.text}`;
  }

  get subjectTaxonomiesHash() {
    return JSON.stringify(this.subjectTaxonomies);
  }

  get currentUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.text || ""
      );
    } else {
      return "";
    }
  }

  get currentIdUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.id || ""
      );
    } else {
      return "";
    }
  }

  get showTaxonomies() {
    return this.clientSubject === "taxonomies";
  }

  get noData(): boolean {
    const keys = Object.keys(this.products);
    let result = true;
    keys.forEach((key) => {
      result =
        result && this.productsFromExclusivity(this.products[key]).length === 0;
    });
    return result;
  }

  compareYearToDisable(): number {
    if (this.filters.weekRange) {
      const yearCompareFilter = this.filters.weekRange.split(",");
      return Number.parseInt(yearCompareFilter[3]);
    }
    return 0;
  }

  weekRangesLabels(): ChartWeekRange[] {
    return Object.keys(this.products).map((weekRange) => {
      return {
        label: this.weekRangeToLabel(weekRange),
        columnName: `col-${weekRange}`,
      };
    });
  }

  async mounted() {
    await this.loadData();
  }

  private async loadData() {
    this.loading = true;
    this.company = await this.getCompany();
    this.initCompareYearsRange();
    await this.initFilters();
    await this.loadProducts();
    await this.loadBroadcasters();
    this.initData();
    this.loading = false;
  }

  private async getCompany() {
    if (this.companyId.length === 0) {
      this.companyId = this.$route.params.companyId;
    }
    return await CompanyService.getPublicCompany(this.companyId);
  }

  get taxonomyLabel() {
    switch (this.taxonomyValue) {
      case "category":
        return "Categoria";
      case "class":
        return "Classe";
      default:
        return "Settore";
    }
  }

  private onBrandClicked(value: any) {
    this.$router.push({
      name: "SpecialInitiativesBrand",
      params: { brandId: value.id },
      query: Object.assign({}, this.$route.query),
    });
  }

  private initData() {
    this.brandHeatmapColumns = [
      {
        name: "brand",
        label: "Brand",
        heatmapDisabled: true,
        locked: true,
      },
      {
        name: "productCount",
        label: "Prodotti",
        small: true,
      },
    ];
    this.taxonomyHeatmapColumns = [
      {
        name: "taxonomy",
        label: this.taxonomyLabel,
        heatmapDisabled: true,
        locked: true,
      },
      {
        name: "productCount",
        label: "Prodotti",
        small: true,
      },
    ];
    for (const weekRange in this.products) {
      this.brandHeatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
      this.taxonomyHeatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    this.arrangeDataInTables();
  }

  private arrangeRowByName(
    kind: "brand" | "taxonomy",
    database: { [key: string]: any },
    weekRange: string,
    product: Product,
    total: number
  ) {
    if (kind === "brand") {
      const brandRow = database[product.subjectName] || {
        id: product.subjectId,
        brand: product.subjectName,
        candidates: [product.iconUrl],
        sector: product.sectorName,
        category: product.categoryName,
        class: product.className,
      };
      brandRow.productCount =
        (brandRow.productCount || 0) + product.productsCount;
      brandRow[`col-${weekRange}`] = this.cellValue(
        total,
        product,
        brandRow[`col-${weekRange}`]
      );
      database[product.subjectName] = brandRow;
    } else {
      const keyName = `${this.taxonomyValue}Name`;
      const key = product[keyName] as string;
      const taxonomyRow = database[key] || {
        taxonomy: key,
        candidates: [product.iconUrl],
        sector: product.sectorName,
        category: product.categoryName,
        class: product.className,
      };
      taxonomyRow.productCount =
        (taxonomyRow.productCount || 0) + product.productsCount;
      taxonomyRow[`col-${weekRange}`] = this.cellValue(
        total,
        product,
        taxonomyRow[`col-${weekRange}`]
      );
      database[key] = taxonomyRow;
    }
  }

  private arrangeDataInTables() {
    this.brandHeatmapRows = [];
    this.taxonomyHeatmapRows = [];
    const brandDatabase: { [key: string]: any } = {};
    const taxonomyDatabase: { [key: string]: any } = {};
    for (const weekRange in this.products) {
      const collection = this.products[weekRange];
      const products = this.productsFromExclusivity(collection);
      const total = this.getTotals(products);
      products.forEach((product) => {
        this.arrangeRowByName(
          "brand",
          brandDatabase,
          weekRange,
          product,
          total
        );
        this.arrangeRowByName(
          "taxonomy",
          taxonomyDatabase,
          weekRange,
          product,
          total
        );
      });
    }
    this.brandHeatmapRows = [];
    for (const subject in brandDatabase) {
      const row: any = {};
      row["id"] = brandDatabase[subject].id;
      row["brand"] = subject;
      row["sector"] = brandDatabase[subject].sector;
      row["category"] = brandDatabase[subject].category;
      row["class"] = brandDatabase[subject].class;
      row["candidates"] = brandDatabase[subject].candidates;
      this.brandHeatmapColumns.forEach((column) => {
        row[column.name] =
          brandDatabase[subject][column.name] || this.cellZeroValue();
      });
      this.brandHeatmapRows.push(row);
    }
    for (const subject in taxonomyDatabase) {
      const row: any = {};
      row["taxonomy"] = subject;
      row["sector"] = taxonomyDatabase[subject].sector;
      row["category"] = taxonomyDatabase[subject].category;
      row["class"] = taxonomyDatabase[subject].class;
      row["candidates"] = taxonomyDatabase[subject].candidates;
      this.taxonomyHeatmapColumns.forEach((column) => {
        row[column.name] =
          taxonomyDatabase[subject][column.name] || this.cellZeroValue();
      });
      this.taxonomyHeatmapRows.push(row);
    }
  }

  private cellValue(
    total: number,
    product: Product,
    currentCellValue?: number | { type: string; value: number; quote: string }
  ) {
    let cellValue = product[this.columnFromUnitOfMeasurement()];
    if (currentCellValue) {
      if (!isNaN(currentCellValue as any)) {
        cellValue += currentCellValue as number;
      } else {
        cellValue += (
          currentCellValue as {
            type: string;
            value: number;
            quote: string;
          }
        ).value;
      }
    }

    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: cellValue,
        quote: this.cellQuoteFromTotal(total, cellValue),
      };
    }
    return cellValue;
  }

  private cellQuoteFromTotal(total: number, cellValue: number) {
    return `${NumberFormatter.format(cellValue)} (${Number(
      (cellValue / total) * 100
    ).toFixed(0)}%)`;
  }

  private cellZeroValue() {
    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: 0,
        quote: 0,
      };
    }
    return 0;
  }

  private columnFromUnitOfMeasurement() {
    if (
      this.unitOfMeasurement === "seconds" ||
      this.unitOfMeasurement === "quoted_seconds"
    ) {
      return "secondsCount";
    } else if (
      this.unitOfMeasurement === "spots" ||
      this.unitOfMeasurement === "quoted_spots"
    ) {
      return "detectionsCount";
    } else {
      return "companiesCount";
    }
  }

  private getTotals(broadcasters: Product[]) {
    const fieldName = this.columnFromUnitOfMeasurement();
    return broadcasters.reduce((acc, broadcaster) => {
      return acc + broadcaster[fieldName];
    }, 0);
  }

  private productsFromExclusivity(broadcasters: ProductsCollection) {
    if (this.exclusivity === "all") {
      return broadcasters.productsAll;
    } else if (this.exclusivity === "my_exclusivity_type") {
      return broadcasters.productsMine;
    } else if (this.exclusivity === "others_exclusivity_type") {
      return broadcasters.productsOthers;
    } else if (this.exclusivity === "shared_exclusivity_type") {
      return broadcasters.productsShared;
    } else {
      return [];
    }
  }

  private weekRangeToLabel(weekRange: string) {
    if (weekRange) {
      const [w1, y1, w2, y2] = weekRange.split(",");
      const weekPickerRange: WeekPickerResult = {
        type: WEEK_PICKER_MODALITY_WEEK_RANGE,
        start: {
          week: Number.parseInt(w1),
          year: Number.parseInt(y1),
        },
        end: {
          week: Number.parseInt(w2),
          year: Number.parseInt(y2),
        },
      };
      return `Settimane ${VWeekPicker.resultToHumanReadable(weekPickerRange)}`;
    }
    return "";
  }

  async loadProductsFromApi(weekRange: string) {
    const filter = this.filtersForAPI("client");
    filter.weekRange = weekRange;
    const productsAll = await SpecialInitiatives.getBrandProducts(
      filter,
      this.companyId
    );

    this.products[weekRange] = productsAll.reduce(
      (acc, product) => {
        switch (product.exclusivityType) {
          case "mine":
            acc.productsMine.push(product);
            break;
          case "others":
            acc.productsOthers.push(product);
            break;
          case "shared":
            acc.productsShared.push(product);
            break;
        }
        return acc;
      },
      {
        productsAll,
        productsMine: [] as Product[],
        productsOthers: [] as Product[],
        productsShared: [] as Product[],
      }
    );
  }

  async loadProducts() {
    this.loading = true;
    this.products = {};
    const filter = this.filtersForAPI("client");
    if (filter.weekRange) {
      await this.loadProductsFromApi(filter.weekRange);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadProductsFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  async loadBroadcastersFromApi(weekRange: string) {
    const filter = this.filtersForAPI("market");
    filter.weekRange = weekRange;
    const broadcastersAll = await SpecialInitiatives.getCompanyBroadcasters(
      filter,
      this.companyId
    );

    this.broadcasters[weekRange] = broadcastersAll.reduce(
      (acc, broadcaster) => {
        switch (broadcaster.exclusivityType) {
          case "mine":
            acc.broadcastersMine.push(broadcaster);
            break;
          case "others":
            acc.broadcastersOthers.push(broadcaster);
            break;
          case "shared":
            acc.broadcastersShared.push(broadcaster);
        }
        return acc;
      },
      {
        broadcastersAll,
        broadcastersMine: [] as Broadcaster[],
        broadcastersOthers: [] as Broadcaster[],
        broadcastersShared: [] as Broadcaster[],
      }
    );
  }

  async loadBroadcasters() {
    this.loading = true;
    this.broadcasters = {};
    const filter = this.filtersForAPI("market");
    if (filter.weekRange) {
      await this.loadBroadcastersFromApi(filter.weekRange);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadBroadcastersFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  private compareYearsToWeekRanges(): string[] {
    const filter = this.filtersForAPI("client");
    const weekRanges: string[] = [];
    if (
      filter.weekRange &&
      this.yearsToCompare &&
      this.yearsToCompare.length > 0
    ) {
      const [w1, y1, w2, y2] = filter.weekRange.split(",");
      const baseYearEnd = Number.parseInt(y2);
      const baseYearStart = Number.parseInt(y1);
      const years = [...this.yearsToCompare];
      for (const year of years.reverse()) {
        const cmpYear = Number.parseInt(year);
        const compareResult = cmpYear - baseYearEnd;
        if (compareResult != 0) {
          const compareWeekRange = [
            w1,
            `${baseYearStart + compareResult}`,
            w2,
            `${baseYearStart + compareResult}`,
          ];
          weekRanges.push(compareWeekRange.join(","));
        }
      }
    }
    return weekRanges;
  }

  private initCompareYearsRange() {
    this.compareYearStart = this.$moment().year();
    this.compareYearEnd = this.compareYearStart - this.compareYearsRange;
  }

  specialInitiativesWeekRanges(): SpecialInitiativesIColumn[] {
    const weekRanges: SpecialInitiativesIColumn[] = [];
    for (const weekRange in this.broadcasters) {
      weekRanges.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    return weekRanges;
  }

  tableQuoted() {
    return this.unitOfMeasurement?.startsWith("quoted");
  }

  private broadcastersFromExclusivity(broadcasters: BroadcastersCollection) {
    if (this.exclusivity === "all") {
      return broadcasters.broadcastersAll;
    } else if (this.exclusivity === "my_exclusivity_type") {
      return broadcasters.broadcastersMine;
    } else if (this.exclusivity === "others_exclusivity_type") {
      return broadcasters.broadcastersOthers;
    } else if (this.exclusivity === "shared_exclusivity_type") {
      return broadcasters.broadcastersShared;
    } else {
      return [];
    }
  }

  broadcastersToTableData(): SpecialInitiativesIData {
    const result: SpecialInitiativesIData = {};
    for (const weekRange in this.broadcasters) {
      result[weekRange] = this.broadcastersFromExclusivity(
        this.broadcasters[weekRange]
      );
    }
    return result;
  }
}
